import { render } from "./AddPointLight.vue?vue&type=template&id=abd0c244"
import script from "./AddPointLight.vue?vue&type=script&lang=js"
export * from "./AddPointLight.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__